import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoUtilityService {
  public encryptText(text: string, secret: string): string | undefined {
    if (!text || !secret) {
      return undefined;
    }
    const key = new TextEncoder().encode(this.decodeBase64(secret.trim())).toString();
    const encrypted = CryptoJS.AES.encrypt(text.trim(), key.toString()).toString();
    return encrypted;
  }

  public decryptText(encryptedText: string, secret: string): string | undefined {
    if (!encryptedText || !secret) {
      return undefined;
    }
    const key = new TextEncoder().encode(this.decodeBase64(secret.trim())).toString();
    const decrypted = CryptoJS.AES.decrypt(encryptedText.trim(), key).toString(CryptoJS.enc.Utf8);
    return decrypted;
  }

  public encodeBase64(text: string): string {
    return btoa(text);
  }

  public decodeBase64(base64: string): string {
    return atob(base64);
  }

  public encryptTextWithBase64Encoding(text: string, secret: string): string | undefined {
    const encryptedText = this.encryptText(text, secret);
    return encryptedText ? this.encodeBase64(encryptedText) : undefined;
  }

  public decryptBase64EncodedText(encryptedBase64Text: string, secret: string): string | undefined {
    const encryptedText = this.decodeBase64(encryptedBase64Text);
    return this.decryptText(encryptedText, secret);
  }
}
